<template>
  <section class="active">
    <div class="container">
      <a-typography-title :level="1">
        社区活动
      </a-typography-title>
      <a-typography-paragraph>
        丰富的线上、线下活动，打造活力开源社区，共建开源新生态。
      </a-typography-paragraph>
      <a-row :gutter="[20,$Store.Public().isGridMatch('>=',$Enum.GridEnum.MD)?50:20]">
        <a-col v-for="(item,index) in expand.case"
               :xs="24" :md="12" :xl="6">
          <div class="item" :class="`i_${index+1}`">
            <div class="image">
              <img alt=""
                   :src="item.image" />
            </div>
            <a-typography-title :level="5">
              {{ item.title }}
            </a-typography-title>
            <a-typography-paragraph>
              {{ item.text }}
            </a-typography-paragraph>
            <a v-if="item.button.click" class="button_n_2"
               @click="item.button.click">
              查看更多
              <ArrowRightOutlined />
            </a>
          </div>
        </a-col>
      </a-row>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_1"
                  @click="$Store.Page().openModal('modalQR','openSource')">
          立即加入
        </a-button>
        <a-button type="link" class="button_1"
                  target="_blank" :href="href.github">
          GitHub
        </a-button>
        <!--<a-button type="link" class="button_1"-->
        <!--          target="_blank" :href="href.document">-->
        <!--    开发者文档-->
        <!--</a-button>-->
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { ArrowRightOutlined } from '@ant-design/icons-vue';

import { DataInterface } from '@interface/public';
import Image_1 from '@resource/image/page/community/active_image_1.png';
import Image_2 from '@resource/image/page/community/active_image_2.png';
import Image_3 from '@resource/image/page/community/active_image_3.png';
import Image_4 from '@resource/image/page/community/active_image_4.png';

export default {
  name: 'community_active',
  components: {
    ArrowRightOutlined
  },
  data(): DataInterface {
    return {
      href: {
        github: 'https://github.com/galaxy-future',
        document: ''
      },
      expand: {
        case: [
          {
            title: '云原生薪火计划',
            text: '诚邀开发者共享开源、共建生态。',
            image: Image_1,
            button: {
              click: () => {
                this.$router.push(`${ $Enum.RouterEnum.NewsDetail }?id=67735311051915268`);
              }
            }
          },
          {
            title: '悬赏计划',
            text: '完成悬赏任务可获取悬赏奖励。',
            image: Image_2,
            button: {
              click: () => {
                this.$router.push(`${ $Enum.RouterEnum.NewsDetail }?id=58344120816500739`);
              }
            }
          },
          {
            title: '全国百城开源大使',
            text: '邀请各城市的开发者为社区作出贡献。',
            image: Image_3,
            button: {
              click: () => {
                $Store.Page().openModal('modalQR', 'cityAmbassador');
              }
            }
          },
          {
            title: '社区双周会',
            text: '定期举办，在交流分享中碰撞出“思想火花”。',
            image: Image_4,
            button: {
              click: () => {
                $Store.Page().openModal('modalQR', 'communityWeek');
              }
            }
          }
        ]
      }
    };
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';

@image: '@{src_image}page/community/';

.active {
  overflow: hidden;
  position: relative;
  z-index: 0;
  width: 100%;
  padding: 0 @padding;
  background-color: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_13, @text);
}

.ant-row {
  margin: @margin_mo 0 0;
}

.item {
  @style: transform @time, box-shadow @time;
  overflow: hidden;
  position: relative;
  max-width: 380px;
  padding-bottom: 10px;
  margin: 0 auto;
  background-color: @color_white;
  border-radius: 20px;
  .shadow(0 15px 25px fade(#6E778B, 30));
  .transition(@style);
  
  &:hover {
    .transform(translateY(-5px));
    .shadow(0 15px 25px fade(#6E778B, 40));
  }
  
  .loop(@i) when (@i<=4) {
    &.i_@{i} {
      .image {
        .bg('@{image}active_image_@{i}_bg.png', auto, 100%);
        background-repeat: repeat-x;
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  .image {
    position: relative;
    height: 150px;
    
    img {
      display: block;
      .position();
      max-width: 100%;
      max-height: 90%;
      margin: auto;
    }
  }
  
  h5.ant-typography {
    padding: 0 @padding;
    margin: 20px 0 0;
    .font(center, @text_big, @color_12, @text_big, true);
  }
  
  div.ant-typography {
    height: (@text+@line)*2;
    padding: 0 @padding;
    margin: 10px 0 0;
    .font(center, @text+@line, @color_13, @text);
  }
  
  .button_n_2 {
    margin: 10px auto 0;
    border: none !important;
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_md) {
  .active {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  .ant-row {
    margin: @margin_mo 0 0;
  }
  
  .item {
    min-height: auto;
    
    h5.ant-typography {
      height: auto;
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      height: auto;
    }
    
    .ant-space {
      margin: 10px auto 15px;
    }
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
    
    .button_1 {
      width: 100px !important;
    }
  }
}
</style>